<h2 mat-dialog-title>Alterações da versão</h2>
<mat-dialog-content>
    <h3>1.4.3</h3>
    <ul> 
        <li>
            Candidato
        </li>
        <ul>
            <li>Visualização Melhorada (Calendário) na tela de entrevista</li>
        </ul>
    </ul>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Processo Seletivo com IA e Relatório com IA</li>
        </ul>
    </ul>
    <h3>1.4.1</h3>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Google Meet - Invite para Agendar Entrevista</li>
        </ul>
    </ul>
    <h3>1.4.0</h3>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Agendar Entrevista Melhorias (arrasta e solta)</li>
        </ul>
    </ul>
    <h3>1.3.9</h3>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Envio de Email (Onsignal)</li>
        </ul>
    </ul>    
    <h3>1.3.8</h3>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Notificações</li>
        </ul>
    </ul>
    <h3>1.3.7</h3>
    <ul> 
        <li>
            Recrutador
        </li>
        <ul>
            <li>Compartilhar e Criativo (Processo Seletivo)</li>
            <li>Retorno da Funcionalidade de Aprovação de Recrutadores</li>
        </ul>
    </ul>
    <h3>1.3.6</h3>
    <ul> 
        <li>
            Recrutador
            <ul>
                <li>Remoção Temporária da Aprovação de Recrutadores</li>
                <li>Início do sistema de notificação</li>
                <li>Teste</li>
                <li>Entrevista</li>
                <li>Notificações</li>
            </ul>
        </li>
    </ul>
    <h3>1.3.5</h3>
    <ul> 
        <li>
            Recrutador
            <ul>
                <li>Melhoria Relatório</li>
            </ul>
        </li>
    </ul>
    <h3>1.3.4</h3>
    <ul> 
        <li>
            Recrutador
            <ul>
                <li>Novo Relatório</li>
                <li>Melhoria no filtro dos candidatos</li>
                <li>Menu Financeiro</li>
                <li>Arquivar Processo Seletivo</li>
                <li>Cupons evento</li>
            </ul>
        </li>
    </ul>
    <h3>1.3.3</h3>
    <ul> 
        <li>
            Recrutador
            <ul>
                <li>Filtro e Busca</li>
                <li>Link de compartilhamento</li>
                <li>Processo seletivo</li>
            </ul>
        </li>
        <li>
            Candidato
            <ul>
                <li>Correção Currículo</li>
            </ul>
        </li>
    </ul>
    <h3>1.3.2</h3>
    <ul> 
        <li>
            Relatório
            <ul>
                <li>Incluir gráficos</li>
                <li>Adicionar filtros de pesquisas</li>
                <li>Exportar xlsx</li>
            </ul>
        </li>
    </ul>
    <ul> 
        <li>
            Formulário
            <ul>
<<<<<<< HEAD
                <li>Adicionado (Campo Sobrenome usuário empresa)</li> 
=======
                <li>Adicionado (Campo Sobrenome usuário empresa)</li>
>>>>>>> origin/lucas-26.08-filtros-processo-seletivo
                <li>Opção de ocultar/mostrar processo seletivo</li>
                <li>Listar as novas informações do Processo Seletivo</li>
                <li>Correção Bug primeiro emprego</li>
                <li>Remoção do passo 5 no formulário de cadastro</li>
                <li>Correção galeria e da foto em dispositivos IOS</li>
            </ul>
        </li>
        <li>
            Pagamento
            <ul>
                <li>Incluir menu financeiro e histórico de pagamentos (Incluir menu financeiro)</li>
                <li>Correção (Modificar Pagamento - Boleto somente após o período grátis)</li>
<<<<<<< HEAD
                <li>Ajuste cobrança cupom prromocional</li>
=======
                <li>Ajuste cobrança cupom promocional</li>
>>>>>>> origin/lucas-26.08-filtros-processo-seletivo
                <li>Incluir Menu Financeiro</li>
            </ul>
        </li>
        <li>
            Processo Seletivo
            <ul>
                <li>Alterar Excluir para Arquivar Processo Seletivo (Correções no Processo Seletivo)</li>
                <li>Correção no icone que mostra as palavras chaves (Criar processo selectivo)</li>
                <li>Correção no icone que mostra as palavras chaves (Criar processo selectivo)</li>
                <li>Correção no Número de Vagas disponíveis e contratados (Criar processo selectivo)</li>
                <li>Mostrar Checkout após período de teste</li>
                <li>Alterando a Cobrança de Usuário para Empresa</li>
                <li>Correção no Processo Seletivo</li>
                <li>Editar Processo Seletivo</li>
                <li>Inclusão de novas informações no cadastro do Processo Seletivo</li>
                <li>Inserir Candidato Manualmente por CPF, Telefone ou Email (Adicionar Barra de Busca)</li>
                <li>Correção Inserir Candidatos (Adicionar Barra de Busca) </li>
                <li>Correção Qtd Vaga (Criar Processo Seletivo)</li>
                <li>Mostrar o número de vagas disponível (Criar Processo Seletivo)</li> 
            </ul>
        </li>
    </ul>
    <h3>1.3.0</h3>
    <ul>
        <li>
            Formulário
            <ul>
                <li>Correção Cadastro etapa 1</li>
                <li>Correção Primeiro Emprego etapa 3</li>
            </ul>
        </li>
        <li>
            Currículo
            <ul>
                <li>Ajuste layout</li>
                <li>Correção Exclusão de Curso</li>
            </ul>
        </li>
        <li>
            Processo Seletivo
            <ul>
                <li>Ajuste formulário de pesquisa</li>
                <li>Melhoria no desempenho e correção de consulta backend</li>
            </ul>
        </li>
    </ul>
    <h3>1.2.9</h3>
    <ul>
        <li>
            Curriculo
            <ul>
                <li>Upload de currículo</li>
                <li>Gerar/Baixar currículo</li>
                <li>Ajuste botão voltar formulário de cadastro</li>
                <li>Inclusão de registro CLT, PJ e Informal</li>
            </ul>
        </li>
    </ul>

    <h3>1.2.8</h3>
    <ul>
        <li>
            Foto
            <ul>
                <li>Atualização do upload de imagens</li>
                <li>Alteração no backend</li>
            </ul>
        </li>
    </ul>

    <h3>1.2.7</h3>
    <ul>
        <li>
            Candidato
            <ul>
                <li>Upload de currículo</li>
                <li>Gerar/Baixar currículo</li>
                <li>Ajuste botão voltar formulário de cadastro</li>
                <li>Inclusão de registro CLT, PJ e Informal</li>
            </ul>
        </li>
        <li>
            Recrutador/Empresa
            <ul>
                <li>Filtro por quantidade de palavras chaves</li>
                <li>Inclusão de novas informações no cadastro do Processo Seletivo</li>
            </ul>
        </li>
    </ul>

    <h3>1.2.6</h3>
    <ul>
        <li>
            Candidato
            <ul>
                <li>Lista de deficiência, para candidato PCD</li>
                <li>Remover [Object Object] no campo cidade - dados pessoais</li>
                <li>Remover mensagem e limpar cache ao sair no app</li>
                <li>Cadastro, quando ensino médio e fundamental (Não obrigar colocar o nome do curso)</li>
                <li>Datas inicio e fim apenas mês e ano</li>
                <li>Integrar os outros formulários dos passos de cadastro com o Mautic</li>
                <li>Autorizo que a Colloca me envie mensagens de vagas e informações sobre a ferramenta</li>
                <li>Autorizo que a Colloca me envie mensagens de vagas e informações sobre a ferramenta</li>
            </ul>
        </li>
        <li>
            Recrutador/Empresa
            <ul>
                <li>Excluir teste, resultados e entrevista quando candidato é removido dos teste</li>
                <li>Mostrar somente teste cadastrado pelo empresa, e permitir edição de perguntas nos teste</li>
                <li>Remover bug no botão de "novo usuário", não abria</li>
                <li>Validar CNPJ e incluir usuários na empresa</li>
            </ul>
        </li>
    </ul>

    <h3>1.1.3</h3>
    <ul>
        <li>
            Recrutador
            <ul>
                <li>Filtro de candidatos, tirar os filtros (cargo, setor e áreas) e buscar esse campo no campo descrição
                    geral</li>
                <li>colocar mensagem na tela inicial "Olá "nome do usuário" seja bem vindo e boa sorte"</li>
                <li>Colocar os circulos na horizontal dos processos (visualização do celular)</li>
                <li>Mostrar sugestão no cargo desejado (cadastro e ediçao)</li>
            </ul>
        </li>
        <li>
            No mobile (Android e Iphone)
            <ul>
                <li>Usar camera nativa do sistema para tirar foto e editar</li>
            </ul>
        </li>
    </ul>

    <h3>1.1.2</h3>
    <ul>
        <li>
            Recrutador
            <ul>
                <li>Checkout para assinatura (frontend)</li>
                <li>Arrumar problema na hora de responder questões</li>
            </ul>
        </li>
        <li>
            Candidato
            <ul>
                <li>Arrumar erro na hora de adicionar candidato na agenda da entrevista</li>
                <li>Problema na correção das questões</li>
            </ul>
        </li>
    </ul>

    <h3>1.1.1</h3>
    <ul>
        <li>
            Recrutador
            <ul>
                <li>Colocar pesquisa por faixa etaria</li>
                <li>Vincular todos os filtros na pesquisa</li>
            </ul>
        </li>
        <li>
            Candidato
            <ul>
                <li>Opção de rejeitar processo seletivo para o candidato</li>
            </ul>
        </li>
    </ul>

    <h3>1.1.0</h3>

    <ul>
        <li>
            Recrutador
            <ul>
                <li>Resolver problema na quantidade de candidatos que aparece nos filtro; ao clicar já sugira os nomes
                    em ordem alfabetica</li>
                <li>Informações do candido que irão aparecer para as empresas: Nome, Sexo, aniversário e idade, Cargo
                    pretendido, Sobre candidato, Estado, Cidade, Bairro</li>
                <li>Voltar cargo desejado no filtro de pesquisa - trocar por area especifica, entener a diferença entre
                    cargo desejado nas tabelas, sugerir nomes ao clique, não esperar escrever</li>
                <li>Mostra pontuação correta dos testes e nota da entrevista do candidato na tela do recrutador</li>
                <li>Tirar cadastro de recrutador na tela de login</li>
                <li>Colocar nome completo do estado no filtro</li>
                <li>Incluir bairro no filtro</li>
                <li>Tirar opacidade do icone de alterar avatar do perfil</li>
            </ul>
        </li>
    </ul>

    <h3>1.0.0</h3>

    <ul>
        <li>
            Candidato
            <ul>
                <li>
                    Processo seletivo
                    <ul>
                        <li>Mostra progresso do candidato (pesquisado, analisado e selecionado)</li>
                        <li>Listar processo seletivo disponiveis</li>
                        <li>Etapas do processo seletivo (Testes, entrevistas e status)</li>
                    </ul>
                </li>
                <li>
                    Perfil e conta pessoal
                    <ul>
                        <li>Alterar dados do perfil do candidato</li>
                    </ul>
                </li>
                <li>
                    Experiência Profissional
                    <ul>
                        <li>Listar histórico</li>
                        <li>Cargos desejado</li>
                        <li>Cadastrar experiência</li>
                        <li>Editar experiência</li>
                        <li>Remover experiência</li>
                    </ul>
                </li>
                <li>
                    Escolaridade
                    <ul>
                        <li>Listar histórico</li>
                        <li>Cadastrar experiência</li>
                        <li>Editar experiência</li>
                        <li>Remover experiência</li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent">Fechar</button>
</mat-dialog-actions>